export function syncValidatorResults(validatorResults, setValidatorResults, isValid, validatorId){

    if(!(validatorId in validatorResults)){
        setValidatorResults((prev) => ({
            ...prev,
            [validatorId]: isValid
        }))
        return;
    }
    validatorResults[validatorId] = isValid
}

export function areAllValidatorsValid(validatorResults){
    for (const [key, value] of Object.entries(validatorResults)) {
      if(!value)
        return false
    }
    return true
}